import { Injectable } from '@angular/core';
import {
  FreeServicesParcelRequestGridDto,
  FspParcelDetailsAttributeDto,
} from './free-services-parcel-request-grid-data-model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GridDataService } from '../../../gk-kendo';

@Injectable({
  providedIn: 'any',
})
export class FreeServicesParcelRequestGridDataService extends GridDataService<FreeServicesParcelRequestGridDto> {
  constructor(private httpClient: HttpClient) {
    super('/api/interesant/przp/dzialki/search', 'POST');
  }

  public fetchParcelDetailsFromApi(
    zamowUuid: string,
    parcelId: number,
  ): Observable<FspParcelDetailsAttributeDto> {
    return this.httpClient.get<FspParcelDetailsAttributeDto>(
      `/api/interesant/przp/zamowienie/${zamowUuid}/dzialka/${parcelId}`,
    );
  }
}
